export const GET_BANK_PAYMENT_TRANSACTIONS = 'GET_BANK_PAYMENT_TRANSACTIONS';
export const BANK_PAYMENT_TRANSACTION_REQUEST = 'BANK_PAYMENT_TRANSACTION_REQUEST';
export const GET_ACCOUNT_ID_WISE_CONSIGNEE_BANK_PAYMENT_TRANSACTIONS = 'GET_ACCOUNT_ID_WISE_CONSIGNEE_BANK_PAYMENT_TRANSACTIONS';
export const BANK_PAYMENT_TRANSACTION_REQUEST_FAILURE = 'BANK_PAYMENT_TRANSACTION_REQUEST_FAILURE';